import EventBus from './EventBus';

const eventBus = new EventBus('common');

export { EventType } from './eventTypes';
export { default as useEventBus } from './useEventBus';
export default eventBus;
